import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { BusinessPostService } from "../services/business_post.service";

// post.resolver.ts
@Injectable({ providedIn: 'root' })
export class PostResolver implements Resolve<any> {
  constructor(private businessPostService: BusinessPostService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.params['id'];
    return this.businessPostService.get({ selected: id , selected_only:true },{
        'X-Skip-Interceptor' : 'true',
    });
  }
}
